module.exports = __webpack_public_path__ + "static/media/choose_us_2_selected.ef05b241.png";